/*
 * Free-shipping celebration.
 * Fires a lightweight confetti burst once when the cart reaches the free-shipping
 * goal. Controlled by the <free-shipping-goal data-celebrate> attribute (toggled
 * from the theme's cart section settings) and de-duplicated per session so it does
 * not replay on every cart update. Resets when the cart drops back below the goal.
 */
(function () {
  if (window.__fsgCelebrateInit) return;
  window.__fsgCelebrateInit = true;

  var SESSION_KEY = 'fsg-celebrated';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function fireConfetti() {
    if (reducedMotion()) return;

    var container = document.createElement('div');
    container.className = 'fsg-confetti';
    var colors = ['#6439FF', '#22c55e', '#f59e0b', '#ef4444', '#3b82f6', '#ec4899'];
    var count = 70;

    for (var i = 0; i < count; i++) {
      var piece = document.createElement('span');
      piece.className = 'fsg-confetti__piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[i % colors.length];
      piece.style.animationDelay = Math.random() * 0.35 + 's';
      piece.style.animationDuration = 1.8 + Math.random() * 1.4 + 's';
      piece.style.setProperty('--drift', (Math.random() * 140 - 70).toFixed(0) + 'px');
      piece.style.setProperty('--spin', (180 + Math.random() * 620).toFixed(0) + 'deg');
      container.appendChild(piece);
    }

    document.body.appendChild(container);
    setTimeout(function () {
      container.remove();
    }, 3600);
  }

  function goalReached(el, totalCents) {
    if (!el) return false;
    var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var goal = Number(el.dataset.minimumAmount) * rate;
    var total = totalCents / 100;
    return goal > 0 && total >= goal;
  }

  function maybeCelebrate(reached, el) {
    if (!el) return;
    if (!reached) {
      sessionStorage.removeItem(SESSION_KEY);
      return;
    }
    if (el.dataset.celebrate === 'false') return;
    if (sessionStorage.getItem(SESSION_KEY) === '1') return;
    sessionStorage.setItem(SESSION_KEY, '1');
    fireConfetti();
  }

  function run() {
    var initEl = document.querySelector('free-shipping-goal');
    if (initEl) {
      maybeCelebrate(goalReached(initEl, Number(initEl.dataset.cartTotal)), initEl);
    }
    document.addEventListener('cart:updated', function (event) {
      var el = document.querySelector('free-shipping-goal');
      maybeCelebrate(goalReached(el, event.detail.cart.items_subtotal_price), el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
